// API service for Needal completions
import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL;

export async function createCompletion(userInput) {
  const response = await axios.post(
    `${baseURL}/completions/create`,
    { userInput },
    { headers: { 'Content-Type': 'application/json' } }
  );
  return response.data;
}
